export const GET_TRUCK_ROUTE_LIST = 'GET_TRUCK_ROUTE_LIST';
export const GET_TRUCK_ROUTE_LIST_LOADING_ERROR =
  'GET_TRUCK_ROUTE_LIST_LOADING_ERROR';
export const GET_TRUCK_ROUTE_LIST_LOADING = 'GET_TRUCK_ROUTE_LIST_LOADING';
export const GET_TRUCK_ROUTE_SCHEDULE_DETAILS =
  'GET_TRUCK_ROUTE_SCHEDULE_DETAILS';
export const GET_TRUCK_ROUTE_SCHEDULE_DETAILS_ERROR =
  'GET_TRUCK_ROUTE_SCHEDULE_DETAILS_ERROR';
export const GET_TRUCK_ROUTE_SCHEDULE_DETAILS_LOADING =
  'GET_TRUCK_ROUTE_SCHEDULE_DETAILS_LOADING';
export const SAVE_TRUCK_ROUTE_SCHEDULE_LOADING =
  'SAVE_TRUCK_ROUTE_SCHEDULE_LOADING';
export const SAVE_TRUCK_ROUTE_SCHEDULE = 'SAVE_TRUCK_ROUTE_SCHEDULE';
export const SAVE_TRUCK_ROUTE_SCHEDULE_ERROR =
  'SAVE_TRUCK_ROUTE_SCHEDULE_ERROR';
export const CLEAR_SAVE_TRUCK_ROUTE_SCHEDULE =
  'CLEAR_SAVE_TRUCK_ROUTE_SCHEDULE';
export const CLEAR_TRUCK_ROUTE_SCHEDULE_ERRORS =
  'CLEAR_TRUCK_ROUTE_SCHEDULE_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckrouteschedule/types.js